import { ChannelType } from '@nemuru-eng/js-api-client';
import React from 'react';

import { Text } from '../../../../shared/components/Text';

export const ChannelTypeOptions = Object.values(ChannelType).map((value) => ({
  value,
  display: <Text tId={value} />,
}));
